import config from '../config';
import cookie from 'js-cookie';

// transforma array em objeto para utilizar no lookup do materialTable
export const transfToLookup = (fieldID: string, fieldNome: string, lista: Array<any>) => {
    const objRetorno:any = {}
    lista.map(l => {
        objRetorno[l.id] = l[fieldNome];
        return l;
    });
    return objRetorno;
};


// injeta o token no objeto post - usado para fazer requests usando post 
export const injectToken = (objectPost:any, token:string ) => {
    if( objectPost ){
        objectPost.token = token;
    }
    return objectPost;
}

// injeta o token na url
export const injectTokenURL = (url:string, token:string ) => {
    // verifica se a url ja possui ? 
    const interrogacao = url.indexOf("?") !== 0 ? "?" : "";
    return url + interrogacao + "token=" + token;
}

// manipula uma variavel
export const tryVar = (v:any, ret=undefined) => {
    try {
        return v === undefined ? ret : v;
    } catch (error) {
        return undefined;
    } 
}

// injeta o nome da aplicacao na string recebida
export const injectNameApp = (str:string) => {
    return config.title_app + str;
}

export const writeCookie = (key:string, value:string, hours:number) => {
    let now = new Date();
    now.setTime(now.getTime() + hours * 3600 * 1000);
    return cookie.set(key, value, { expires: now });
}

export const readCookie = (key:string) => {
    return cookie.get(key);
}

export const removeCookie = (key:string) => {
    return cookie.remove(key);
}

export const transformReactSelect = (list:any[], labelName:string, valueName:string, optionsActual:number) => {
	if (!list) {
		return [];
	}
	const newList:any = [];
	list.map(l => {
		// antes de incluir na lista verifica se esse item ja não foi escolhido, para que a lista apresente apenas os itens ainda não escolhidos
		let existe = false;
		// garante que optionsActual sera uma String
		optionsActual && optionsActual.toString().split(",").map(o => {
			existe = o === l[valueName] ? true : existe;
			return o;
		})
		!existe && newList.push({ label: l[labelName], value: l[valueName] });
		return l;
	});
	return newList;
}

export const generateNewStateOnOff = ( id: string, state: any , newState: any ) => {
	state[id] = newState;
	return {...state};
}

export function removeLastComma(str:string){        
    var n=str.lastIndexOf(",");
    var newStr=str.substring(0,n) 
    return newStr;
}


